import {DropdownMenuItem} from "@reside/ui";

import {getResidentTestId} from "../../helper";
import {
  AdmissionFromSearch,
  hasArbitrationDocument,
} from "../../../../services/AdmissionsService";
import {getArbitrationPdfUrl, withAccessToken} from "../../../../utils/url";

const openArbitrationPDF = (admission: AdmissionFromSearch) =>
  window.open(
    admission.resources?.arbitrationPdf?.downloadUrl
      ? withAccessToken(admission.resources.arbitrationPdf.downloadUrl)
      : getArbitrationPdfUrl(admission.id),
    "_blank",
  );

export const DownloadArbitrationPDFDropdownItem = ({
  admission,
  ...props
}: {
  admission: AdmissionFromSearch;
}) => {
  if (!hasArbitrationDocument(admission.templateDocumentTypes)) {
    return null;
  }

  return (
    <DropdownMenuItem
      pointer
      onClick={() => {
        openArbitrationPDF(admission);
      }}
      testId={getResidentTestId(admission, "downloadArbitrationPdf")}
      {...props}
    >
      Download Arbitration
    </DropdownMenuItem>
  );
};
